import { Component, OnInit } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {IonicModule, ModalController} from "@ionic/angular";

@Component({
  selector: 'app-only-mobile',
  templateUrl: './only-mobile.component.html',
  styleUrls: ['./only-mobile.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    IonicModule
  ]
})
export class OnlyMobileComponent  implements OnInit {

  constructor(private modalController: ModalController,) { }

  ngOnInit() {}

  onClose(){
    this.modalController.dismiss();
  }

}
